<template>
  <div>
    <!-- 頭部 -->
    <Header></Header>
    <div class="lbt">
      <el-carousel indicator-position="outside" height="550px">
        <el-carousel-item v-for="item in ban1.length" :key="item" >
            <el-image class="ban1_dt" :src="ban1[item-1].url"></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>

    
    <!-- 特許經銷商 -->
    <div class="dealers-container">
    <h1 class="ppjs-title">*40週年彈簧床褥特許經銷商*</h1>

    <!-- 連鎖品牌區 -->
    <section class="section">
      <h2 class="section-title">連鎖品牌</h2>
      <div
        v-for="(chain, chainKey) in chainStores"
        :key="chainKey"
        class="area-section"
      >
        <div class="area-header" @click="toggleChain(chainKey)">
          <h3 class="chain-name">{{ chain.name }}</h3>
          <span class="toggle-icon">{{ expandedChains[chainKey] ? '−' : '+' }}</span>
        </div>
        <transition name="fade-slide">
          <div v-show="expandedChains[chainKey]" class="stores-grid">
            <div
              v-for="(store, idx) in chain.stores"
              :key="idx"
              class="store-card"
            >
              <h4 class="store-name">{{ store.branch }}</h4>
              <p class="store-address">{{ store.address }}</p>
            </div>
          </div>
        </transition>
      </div>
    </section>

    <!-- 地區分佈區 -->
    <section class="section">
      <h2 class="section-title">地區分佈</h2>
      <div
        v-for="(area, areaKey) in regionalStores"
        :key="areaKey"
        class="area-section"
      >
        <div class="area-header" @click="toggleArea(areaKey)">
          <h3>{{ area.name }}</h3>
          <span class="toggle-icon">{{ expandedAreas[areaKey] ? '−' : '+' }}</span>
        </div>
        <transition name="fade-slide">
          <div v-show="expandedAreas[areaKey]" class="stores-grid">
            <div
              v-for="(store, idx) in area.stores"
              :key="idx"
              class="store-card"
            >
              <h4 class="store-name">{{ store.name }}</h4>
              <p class="store-address">{{ store.address }}</p>
            </div>
          </div>
        </transition>
      </div>
    </section>
    </div>




    <!-- 新產品 -->
    <div class="cxcpdk">
      <div class="cxcp-title">新品推薦</div>
      <div class="cxcp-subtitle">堅持創新，完善產品</div>
      <div><el-image :src="jt"></el-image></div>
      <div class="cxcpmk clearfix">
        <div
          class="cxcp"
          @click="openBox(item.prod_sn)"
          v-for="item of cxcp"
          :key="item.index"
        >
          <el-image class="cxcp-tp" :src="item.url"></el-image>
          <div class="cxcp-wz">{{ item.prod_des }}</div>
        </div>
      </div>
    </div>

    <!-- 品牌介紹 -->
    <div>
      <div class="ppjs-title">品牌介紹</div>
      <div class="ppjs-subtitle">不忘初心，堅持創新</div>
      <div class="ppjs">
        <div><el-image class="ppjs-left" :src="ppjs"></el-image></div>
        <div class="ppjs-right">
          <div class="ppjs-right-title">IDEA</div>
          <div class="ppjs-right-subtitle">PHASE ——</div>
          <div class="ppjs-right-wz">
            <span class="ppjs-right-gs" @click="toAbout"
              >樂滿門床具有限公司</span
            >
            <span>
              經過30多年的發展，公司始終恪守
              "創新,品質，服務，經濟，奉獻感恩"的十二字理念。吸收新思想，嚴格控制品質，跟蹤全方位服務，堅持生產優質產品。</span
            >
          </div>
        </div>
      </div>
    </div>

    <Footer></Footer>
    <Box
      :dialogVisible="box.dialogVisible"
      :goods_id="box.goods_id"
      @close="boxClose"
    ></Box>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Box from "@/components/Box";
export default {
  name: "home",
  data() {
    return {
      ban1: [{id: "00001", url: ""}],
      xl: [
        "https://nicedream.top:8202/gw_lmm/home1.jpg",
        "https://nicedream.top:8202/gw_lmm/home2.jpg",
        "https://nicedream.top:8202/gw_lmm/home3.jpg",
      ],
      jt: "https://nicedream.top:8202/gw_lmm/home4.png",
      cxcp:[],
      //   品牌介紹
      ppjs: "https://nicedream.top:8202/gw_lmm/home5.png",
      box: {
        dialogVisible: false,
        goods_id: "",
      },
      place:"R",
      // 折叠状态
      expandedChains: {
        feicui: true,
        aihuangbao: true,
        tongbao: true
      },
      expandedAreas: {
        hk: true,
        kl: true,
        nt: true,
        macau: true
      },
          // ===== 連鎖品牌數據 =====
      chainStores: {
        feicui: {
          name: '翡翠籐器有限公司',
          stores: [
            { branch: '灣仔店', address: '灣仔道181號長春大廈地下A號鋪連一樓' },
            { branch: '旺角店', address: '旺角洗衣街187號伊利莎大廈地下' },
            { branch: '上水店', address: '上水新成路69號地下' },
            { branch: '天水圍店', address: '天水圍嘉湖銀座二期2樓207舖' },
            { branch: '將軍澳店', address: '將軍澳唐明街將軍澳2號尚德邨尚德廣場二樓231A號鋪' }
          ]
        },
        aihuangbao: {
          name: '愛皇寶國際貿易公司',
          stores: [
            { branch: '深水埗店', address: '深水埗西邨路19號南昌薈F105舗' },
            { branch: '黃大仙店', address: '黃大仙竹園邨廣場1/FS105A鋪' },
            { branch: '官塘店', address: '官塘秀茂坪商場1樓111B' },
            { branch: '將軍澳店（彩明）', address: '將軍澳彩明商場210鋪' },
            { branch: '將軍澳店（千色百貨）', address: '將軍澳千色店百貨L2床品' }
          ]
        },
        tongbao: {
          name: '通寶行',
          stores: [
            { branch: '藍田店', address: '官塘藍田德田商場地下G3鋪' },
            { branch: '官塘店', address: '官塘翠屏北商場119-120號' },
          ]
        }
      },
            regionalStores: {
        hk: {
          name: '港島區',
          stores: [
            { name: '財華傢俬設計', address: '西環皇后大道西322號振坤樓地下' },
            { name: '利豐傢俬公司', address: '香港仔大道88號地下B鋪' },
            { name: '威信傢俬公司', address: '香港仔大道212A鋪' }
          ]
        },
        kl: {
          name: '九龍區',
          stores: [
            { name: '昌盛傢俬', address: '深水埗青山道279號地下' },
            { name: '成興傢俬裝飾有限公司', address: '深水埗元洲街18號渭濱樓地下及2樓下' },
            { name: '順興傢俬裝飾公司', address: '土瓜灣北帝街2號地下' },
            { name: '森源室內設計', address: '土瓜灣馬頭圍道234號地下' },
            { name: '金星傢俬', address: '新蒲崗爵祿街25號地下' },
            { name: '科雅室內設計', address: '官塘順安村安群樓地下7號鋪' },
            { name: '民豐傢俬', address: '官塘牛頭角道241號地鋪' },
            { name: '強榮傢俬', address: '長沙灣青山道444-450號康利大廈地下D舖' },
            { name:'原木家居設計',address:'九龍彩雲邨第二期商場三樓A313鋪'}
          ]
        },
        nt: {
          name: '新界區',
          stores: [
            { name: '合宜傢俬中心', address: '葵涌石梨商場B319B號鋪' },
            { name: '益發傢俬', address: '葵涌和宜合道64號地下' },
            { name: '鴻利傢俬', address: '荃灣青山公路185號荃勝大廈1-2樓' },
            { name: '嘉豐設計有限公司', address: '荃灣街市街146號坤成樓地鋪' },
            { name: '家麗傢俬裝修設計公司', address: '屯門明藝街6-14號地下E 鋪' },
            { name: '美適傢俬倉', address: '屯門震寰路9號好收成工業大廈地下' },
            { name: '永順傢俬公司', address: '屯門湖翠路138號啟豐商場1/F，48-49鋪' },
            { name: '龍藝軒傢俬裝飾設計', address: '元朗大棠道48-56號一樓全層' },
            { name: '麗晶傢俬', address: '屯門建發街11號好景大廈A座7樓11室' },
            { name: '利達傢俬家居廣場', address: '元朗擊壤路13-17號順發大廈L舖地下一樓全層' },
            { name: '永利恒傢俬有限公司', address: '粉嶺聯和墟和豐街58號地下' },
            { name: '志利傢俬', address: '上水新成路22號地下' },
            { name: '長榮傢居設計有限公司', address: '大埔廣福道85號地鋪' },

          ]
        },
        macau: {
          name: '澳門',
          stores: [
            { name: '建輝傢俬', address: '澳門渡船街1號A-B地下' }
          ]
        }
      },
    };
  },
  created(){
    if(sessionStorage.getItem("company_sn")!=null){
      this.place=sessionStorage.getItem("company_sn")
        this.queryBanner()
        this.queryProd()
    }
  },
  methods: {
    // 查询广告
    queryBanner() {
      this.$api.banner({place:this.place}).then(
        res => {
          console.log(res)
          if (res.state == 10000) {
            this.ban1=res.data.banner
          } else {
            this.$message.error(res.msg);
          }
        },
        () => {
          this.$message.error("请求超时");
        }
      );
    },
    // 查询推荐货品
    queryProd() {
      console.log(this.place)
      this.$api.queryprod({company_sn:this.place,category_sn:"",high:1}).then(
        res => {
          if (res.state == 10000) {
            this.cxcp=res.data.prod
            console.log(this.cxcp)
          } else {
            this.$message.error(res.msg);
          }
        },
        () => {
          this.$message.error("请求超时");
        }
      );
    },
    openBox(goods_id) {
      this.box.dialogVisible = true;
      this.box.goods_id = goods_id;
    },
    // 弹窗的搜索关闭
    boxClose(val) {
      this.box.dialogVisible = val;
    },
    // 跳转到梳化
    toSf() {
      this.$router.push({ path: "/goods/sf" });
    },
    // 跳转到床墊
    toCd() {
      this.$router.push({ path: "/goods/cd" });
    },
    // 跳转到床品
    toCp() {
      this.$router.push({ path: "/goods/cp" });
    },
    // 跳转到床品
    toAbout() {
      this.$router.push({ path: "/about" });
    },
  },
  components: { Header, Footer, Box },
};
</script>

<style scoped>
/* 輪播圖模塊 */
.lbt {
  width: 100%;
  height: 550px;
}
.ban1_dt {
  width: 100%;
  height: 550px;
}
.ban1_pt1 {
  width: 350px;
  height: 350px;
  position: relative;
  top: -400px;
}
.ban1_wz1 {
  font-size: 45px;
  position: relative;
  top: -660px;
  color: #fff;
  font-family: fontface__幼圆__7__607228568617;
}
.ban1_wz2 {
  position: relative;
  top: -645px;
  font-size: 22px;
}
.ban1_wz3 {
  position: relative;
  top: -630px;
  font-size: 18px;
  color: #fff;
}

/* 創新產品 */
.cxcpdk {
  padding-top: 100px;
  background: rgb(244, 244, 244);
}
.cxcp-title {
  font-size: 2.5rem;
  font-weight:700;
  color: #2b2b2b;
}
.cxcp-subtitle {
  line-height: 50px;
  color: #444444;
}
.cxcpmk {
  width: 1080px;
  margin: 0 auto;
}
.cxcp {
  float: left;
  width: 320px;
  height: 380px;
  margin: 20px;
  background-color: #ffffff;
  /* box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.1); */
}
.cxcp-tp {
  margin-top: 30px;
  width: 320px;
  height: 250px;
}

/* 系列 */
.xl-shang {
  display: flex;
  justify-content: flex-start;
  height: 500px;
}
.xl-tp {
  height: 500px;
}
.xl-shang-left-wz {
  position: relative;
  top: -400px;
  text-align: right;
  margin-right: 150px;
}
.xl-shang-right-wz {
  position: relative;
  top: -400px;
  text-align: left;
  margin-left: 150px;
}
.xl-shang-title {
  font-size: 36px;
  color: #ffffff;
  margin-bottom: 40px;
}
.xl-shang-subtitle {
  line-height: 1.8;
  font-size: 14px;
  color: #ffffff;
}
.xl-shang-title2 {
  font-size: 36px;
  color: #3e3e3e;
  margin-bottom: 40px;
}
.xl-shang-subtitle2 {
  line-height: 1.8;
  font-size: 14px;
  color: #3e3e3e;
}
.xl-xia-wz {
  position: relative;
  top: -400px;
  text-align: left;
  margin-left: 500px;
}
.xl-xia-title {
  font-size: 36px;
  color: #ffffff;
  margin-bottom: 40px;
}
.xl-xia-subtitle {
  line-height: 1.8;
  font-size: 14px;
  color: #ffffff;
}
.xl-subtitle {
  height: 80px;
}
.mbtn {
  margin-top: 40px;
}

/* 品牌介紹 */
.ppjs-title {
  font-size: 2.5rem;
  font-weight:700;
  color: #2b2b2b;
}
.ppjs-subtitle {
  line-height: 50px;
  color: #444444;
  margin-bottom: 20px;
}
.ppjs {
  display: flex;
  justify-content: flex-start;
}
.ppjs-left {
  height: 560px;
}
.ppjs-right {
  width: 450px;
  text-align: left;
  margin: 100px 0 0 100px;
}
.ppjs-right-title {
  color: rgb(179, 141, 84);
  font-size: 54px;
  font-family: impact;
}
.ppjs-right-subtitle {
  color: #333;
  font-size: 54px;
  font-family: impact;
}
.ppjs-right-wz {
  margin-top: 50px;
  font-size: 14px;
  line-height: 24px;
  color: #999999;
}
.ppjs-right-gs {
  color: rgb(179, 141, 84);
}


.dealers-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  font-family: 'Segoe UI', 'Microsoft JhengHei', 'PingFang HK', sans-serif;
  color: #333;
  line-height: 1.6;
}

.title {
  text-align: center;
  font-size: 2.4rem;
  margin-bottom: 2.5rem;
  color: #2c3e50;
  font-weight: 700;
}

.section {
  margin-bottom: 3rem;
}

.section-title {
  font-size: 1.8rem;
  margin-bottom: 1.5rem;
  color: #2d3748;
  border-bottom: 2px solid #e2e8f0;
  padding-bottom: 0.5rem;
}

.area-section {
  margin-bottom: 1.8rem;
}

.area-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.9rem 1.2rem;
  background-color: #f8fafc;
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 0.2s;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

.area-header:hover {
  background-color: #edf7ff;
}

.chain-name,
.area-header h3 {
  margin: 0;
  font-size: 1.4rem;
  font-weight: 600;
  color: #2b6cb0;
}

.toggle-icon {
  font-size: 1.4rem;
  font-weight: bold;
  color: #4a5568;
}

.stores-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 1.3rem;
  margin-top: 1rem;
  padding: 0 0.5rem;
}

.store-card {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  transition: transform 0.25s, box-shadow 0.25s;
}

.store-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
}

.store-name {
  margin: 0 0 0.7rem 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #2c5282;
}

.store-address {
  margin: 0;
  font-size: 1.05rem;
  line-height: 1.55;
  color: #4a5568;
}

/* 折叠动画 */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.35s ease;
}
.fade-slide-enter,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-12px);
}

/* 响应式 */
@media (max-width: 768px) {
  .stores-grid {
    grid-template-columns: 1fr;
  }
  .dealers-container {
    padding: 1.2rem;
  }
  .title {
    font-size: 2rem;
  }
  .section-title {
    font-size: 1.5rem;
  }
}

</style>
